import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExternalPreview = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.2529 7.6327C16.5768 7.23126 17.1648 7.16838 17.5662 7.49226C17.9676 7.81613 18.0305 8.40412 17.7066 8.80556L11.7396 16.2016C11.4405 16.5723 10.9162 16.6543 10.5216 16.4097C10.4045 16.3641 10.2948 16.2941 10.2003 16.1996L7.5587 13.558C7.19397 13.1933 7.19397 12.602 7.5587 12.2372C7.92343 11.8725 8.51477 11.8725 8.8795 12.2372L10.9044 14.2621L16.2529 7.6327Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M23.001 12.001C23.001 18.0761 18.0761 23.001 12.001 23.001C5.92584 23.001 1.00098 18.0761 1.00098 12.001C1.00098 5.92584 5.92584 1.00098 12.001 1.00098C18.0761 1.00098 23.001 5.92584 23.001 12.001ZM21.201 12.001C21.201 17.082 17.082 21.201 12.001 21.201C6.91996 21.201 2.80098 17.082 2.80098 12.001C2.80098 6.91996 6.91996 2.80098 12.001 2.80098C17.082 2.80098 21.201 6.91996 21.201 12.001Z",
		fill: "currentColor"
	})]
});
export default SvgExternalPreview;
